(() => {
  let scheduled = false;
  const text = {
    now: 'СЕГА',
    market: 'Пазарна цена',
    sort: 'Сортиране',
    recommended: 'Препоръчано',
    newest: 'Най-нови',
    lowHigh: 'Цена: ниска към висока',
    highLow: 'Цена: висока към ниска',
    best: 'Най-продавани'
  };
  const productAreaSelectors = [
    '.cloud-search-filters-products',
    '.template-search #product-grid',
    '.template-search .product-grid',
    '#cloud_search_filters_root .product-grid',
    '#cloud-search-products'
  ];
  const withinProductAreas = (selector) => productAreaSelectors
    .map((area) => `${area} ${selector}`)
    .join(',');

  if (/\/(?:a\/)?search(?:\/|$)/i.test(location.pathname)) {
    document.documentElement.classList.add('sxt-search-page');
  }

  const moneyValue = (value) => {
    const source = String(value || '').replace(/\u00a0/g, ' ');
    const match = source.match(/([0-9][0-9\s.,]*)\s*(?:€|EUR)/i);
    if (!match) return 0;
    let number = match[1].replace(/\s/g, '');

    if (number.includes(',')) {
      number = number.replace(/\./g, '').replace(',', '.');
    } else if ((number.match(/\./g) || []).length > 1 || /\.\d{3}$/.test(number)) {
      number = number.replace(/\./g, '');
    }
    return Number.parseFloat(number) || 0;
  };

  const center = (element) => {
    if (!element) return;
    element.style.setProperty('width', '100%', 'important');
    element.style.setProperty('max-width', 'none', 'important');
    element.style.setProperty('margin-inline', 'auto', 'important');
    element.style.setProperty('text-align', 'center', 'important');
  };

  const normalizeCloudBlocks = () => {
    document.querySelectorAll(withinProductAreas('.cs-price-block')).forEach((block) => {
      if (block.closest('.details-top-text')) return;
      if (block.dataset.sxtV25 === 'true' && block.querySelector('.sxt-price-now')) {
        center(block);
        return;
      }

      const prices = [...block.querySelectorAll('.price')];
      const currentNode = block.querySelector('.cs-has-list-price')
        || prices.find((node) => !node.classList.contains('cs-list-price'));
      const compareNode = block.querySelector('.cs-list-price');
      if (!currentNode) return;

      const current = currentNode.textContent.trim();
      const compare = compareNode?.textContent.trim() || '';
      const currentValue = moneyValue(current);
      const compareValue = moneyValue(compare);
      const discount = compareValue > currentValue && compareValue > 0
        ? Math.round(((compareValue - currentValue) / compareValue) * 100)
        : 0;

      block.dataset.sxtV25 = 'true';
      block.dataset.sxtV22 = 'true';
      block.dataset.sxtV7 = 'true';
      block.dataset.sxtDiscount = String(discount);
      block.dataset.sxtPrice = String(currentValue);
      block.classList.add('sxt-price-grid');
      block.classList.toggle('sxt-price-grid--sale', discount > 0);
      block.innerHTML = `<div class="sxt-price-now">${discount >= 50 ? `<span class="sxt-price-now__label">${text.now}</span>` : ''}<span class="sxt-current-grid"></span></div>${compare ? `<div class="sxt-price-reference">${text.market} <s></s>${discount ? ` <strong>(-${discount}%)</strong>` : ''}</div>` : ''}`;
      block.querySelector('.sxt-current-grid').textContent = current;
      const market = block.querySelector('.sxt-price-reference s');
      if (market) market.textContent = compare;

      center(block);
      center(block.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]'));
    });
  };

  const normalizeThemeBlocks = () => {
    document.querySelectorAll(withinProductAreas('.sxt-price-grid')).forEach((grid) => {
      if (grid.dataset.sxtV25 === 'true' && grid.querySelector('.sxt-price-now')) {
        center(grid);
        return;
      }
      if (grid.querySelector('.sxt-price-now')) {
        grid.dataset.sxtV25 = 'true';
        grid.dataset.sxtV22 = 'true';
        grid.dataset.sxtV7 = 'true';
        center(grid);
        center(grid.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]'));
        return;
      }
      const discountNode = grid.querySelector('.sxt-discount-grid');
      const compareNode = grid.querySelector('.sxt-compare-grid');
      const currentNode = grid.querySelector('.sxt-current-grid');
      if (!currentNode) return;

      const discount = Math.abs(Number.parseInt(discountNode?.textContent || '0', 10)) || 0;
      const current = currentNode.textContent.trim();
      const compare = compareNode?.textContent.trim() || '';

      grid.dataset.sxtV25 = 'true';
      grid.dataset.sxtV22 = 'true';
      grid.dataset.sxtV7 = 'true';
      grid.dataset.sxtDiscount = String(discount);
      grid.dataset.sxtPrice = String(moneyValue(current));
      grid.classList.toggle('sxt-price-grid--sale', discount > 0);
      grid.innerHTML = `<div class="sxt-price-now">${discount >= 50 ? `<span class="sxt-price-now__label">${text.now}</span>` : ''}<span class="sxt-current-grid"></span></div>${compare ? `<div class="sxt-price-reference">${text.market} <s></s>${discount ? ` <strong>(-${discount}%)</strong>` : ''}</div>` : ''}`;
      grid.querySelector('.sxt-current-grid').textContent = current;
      const market = grid.querySelector('.sxt-price-reference s');
      if (market) market.textContent = compare;
      center(grid);
      center(grid.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]'));
    });
  };

  const ensureSort = () => {
    const root = document.querySelector('#cloud_search_filters_root');
    const rail = root?.querySelector('.cloud-search-page-controls__filters');
    const productContainer = document.querySelector('.cloud-search-filters-products .product-grid-container');
    if (!rail || !rail.querySelector('.cloud-search-filter')) return;
    const nativeSelect = [...root.querySelectorAll('.cloud-search-page-controls select:not(#SxtAppSort)')].find(select=>!select.closest('.cloud-search-filter'));
    if (nativeSelect) {
      let wrapper = nativeSelect.closest('.sxt-native-sort-v83, [class*="__sorting"], [class*="__sort-by"], [class*="__sortby"]');
      if (!wrapper || wrapper === root || wrapper.contains(rail)) {
        wrapper = nativeSelect.parentElement;
        if (!wrapper || wrapper === rail || wrapper.contains(rail) || wrapper.querySelector('.cloud-search-filter')) {
          wrapper = document.createElement('div');
          nativeSelect.before(wrapper); wrapper.append(nativeSelect);
        }
      }
      wrapper.classList.add('sxt-native-sort-v83');
      if (!nativeSelect.getAttribute('aria-label') && !nativeSelect.labels?.length) nativeSelect.setAttribute('aria-label',text.sort);
      if (wrapper.parentElement !== rail || rail.lastElementChild !== wrapper) rail.append(wrapper);
      root.querySelectorAll('.sxt-app-sortbar').forEach(bar => bar.remove());
      return;
    }
    if (!productContainer) return;
    const params = new URLSearchParams(location.search);
    const selected = params.get('sort_by') || 'manual';
    let bar = root.querySelector('.sxt-app-sortbar');
    if (!bar) {
      bar = document.createElement('div'); bar.className='sxt-app-sortbar';
      bar.innerHTML = `<label for="SxtAppSort">${text.sort}</label><select id="SxtAppSort" aria-label="${text.sort}"><option value="manual">${text.recommended}</option><option value="created-descending">${text.newest}</option><option value="price-ascending">${text.lowHigh}</option><option value="price-descending">${text.highLow}</option><option value="best-selling">${text.best}</option></select>`;
      bar.querySelector('select').addEventListener('change', event => {
        const next = new URL(location.href);
        if (event.target.value === 'manual') next.searchParams.delete('sort_by');
        else next.searchParams.set('sort_by',event.target.value);
        location.assign(next.toString());
      });
    }
    const select = bar.querySelector('select');
    if ([...select.options].some(option=>option.value===selected)) select.value=selected;
    bar.classList.add('sxt-app-sortbar--chip');
    if (bar.parentElement !== rail || rail.lastElementChild !== bar) rail.append(bar);
  };

  const prepareMobileFilters = () => {
    const root = document.querySelector('#cloud_search_filters_root');
    const rail = root?.querySelector('.cloud-search-page-controls__filters');
    if (!rail) return;
    const filters = [...rail.children].filter(node=>node.matches('.cloud-search-filter'));
    if (!filters.length) return;
    root.classList.add('sxt-filter-layout-v83');
    const priority = [ /^(тип|вид|категория|type|product type|category)$/i, /^(модел|модели|model|models)$/i, /^(размер|размери|size|sizes)$/i, /^(цвят|цветове|цвятове|color|colour|colors|colours)$/i, /^(марка|марки|brand|brands|vendor)$/i ];
    filters.forEach((filter,index) => {
      const name = String(filter.dataset.filterName || filter.querySelector('.cloud-search-filter__name')?.textContent || '').replace(/\s+/g,' ').split(':')[0].trim();
      if (!filter.dataset.sxtFilterIndex) filter.dataset.sxtFilterIndex=String(index+1);
      const rank = priority.findIndex(pattern=>pattern.test(name));
      filter.dataset.sxtFilterRank = String(rank<0 ? 100+Number(filter.dataset.sxtFilterIndex) : rank);
      filter.style.setProperty('order',filter.dataset.sxtFilterRank,'important');
      filter.classList.toggle('sxt-filter-search-control', /^(потърси|search)$/i.test(name));
      if (filter.getAttribute('aria-label') !== name) filter.setAttribute('aria-label',name);
    });
    const sorted=[...filters].sort((a,b)=>Number(a.dataset.sxtFilterRank)-Number(b.dataset.sxtFilterRank));
    if (filters.some((filter,index)=>filter!==sorted[index])) sorted.forEach(filter=>rail.append(filter));
    const sidebar=root.querySelector('#cloud_search_filters_sidebar');
    if (sidebar) sidebar.classList.toggle('sxt-filter-sidebar-inline-v83',sidebar.contains(rail));
  };

  const enhance = () => {
    scheduled = false;
    normalizeCloudBlocks();
    normalizeThemeBlocks();
    prepareMobileFilters();
    ensureSort();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  document.addEventListener('cloud-search:render', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.addEventListener('popstate', schedule);
  window.addEventListener('resize', schedule);
  schedule();
})();

/* V82: search presentation only; the provider still owns search and navigation. */
(() => {
  if (window.SXTSearchV82) return;
  window.SXTSearchV82 = true;
  const style = document.createElement('style');
  style.id = 'sxt-search-v82';
  style.textContent = `
    #cloud-search-results .sxt-search-grid-v82,
    #predictive-search-results-products-list {
      display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;
      gap:24px 12px!important;padding:16px!important;margin:0!important;list-style:none!important;
    }
    #cloud-search-results .sxt-search-grid-v82 > :not(.sxt-search-card-v82) {grid-column:1/-1}
    #cloud-search-results .sxt-search-card-v82,
    #predictive-search-results-products-list > li {
      display:flex!important;flex-direction:column!important;position:relative;
      width:auto!important;min-width:0!important;max-width:none!important;height:auto!important;
      margin:0!important;padding:0 0 14px!important;gap:10px!important;
      border:0!important;border-bottom:1px solid #e6e3dc!important;background:#fff!important;
      box-shadow:none!important;float:none!important;text-align:center!important;
    }
    #cloud-search-results .sxt-search-card-v82 .sxt-search-media-v82 {
      display:block!important;float:none!important;width:100%!important;max-width:none!important;
      height:250px!important;margin:0!important;padding:0!important;background:#fff!important;
    }
    #cloud-search-results .sxt-search-card-v82 img {
      display:block!important;width:100%!important;max-width:100%!important;height:250px!important;
      object-fit:contain!important;object-position:center!important;margin:0 auto!important;
    }
    #cloud-search-results .sxt-search-card-v82 .cs-item-details {
      display:flex!important;flex-direction:column!important;gap:8px!important;
      width:100%!important;min-width:0!important;max-width:none!important;
      float:none!important;padding:0!important;margin:0!important;text-align:center!important;
    }
    #cloud-search-results .sxt-search-card-v82 .cs-product-link,
    #cloud-search-results .sxt-search-card-v82 [id^="cloud-search-option-"][id$="-name"] {
      display:block!important;font-family:inherit!important;font-size:12px!important;
      line-height:1.4!important;font-weight:400!important;letter-spacing:.03em!important;
      text-transform:uppercase!important;text-align:center!important;color:#171717!important;
      width:100%!important;white-space:normal!important;overflow-wrap:anywhere!important;text-decoration:none!important;
    }
    #cloud-search-results .sxt-search-card-v82 a:focus-visible,
    #predictive-search-results-products-list a:focus-visible {outline:2px solid #660033;outline-offset:3px}
    #cloud-search-results .sxt-search-card-v82 .sxt-search-price-v82,
    #cloud-search-results .details-top-text.sxt-search-price-v82 {
      display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;
      gap:4px!important;width:100%!important;max-width:none!important;margin:0!important;padding:0!important;text-align:center!important;
    }
    #cloud-search-results .sxt-search-price-v82 .sxt-search-now-v82,
    #cloud-search-results .sxt-search-price-v82 .sxt-search-now-v82 * {
      display:inline!important;float:none!important;width:auto!important;margin:0!important;padding:0 .1em!important;
      font-size:16px!important;font-weight:700!important;line-height:1.3!important;
      color:#171717!important;text-align:center!important;text-decoration:none!important;
      background:none!important;text-decoration-line:underline!important;text-decoration-color:#660033!important;text-decoration-style:solid!important;text-decoration-thickness:1px!important;text-underline-offset:3px!important;text-decoration-skip-ink:none!important;
    }
    #cloud-search-results .sxt-search-price-v82 .sxt-search-market-v82,
    #cloud-search-results .sxt-search-price-v82 .sxt-search-market-v82 * {
      display:inline!important;width:auto!important;margin:0!important;padding:0!important;
      font-size:10px!important;font-weight:400!important;line-height:1.5!important;
      color:#666!important;background:none!important;text-align:center!important;
    }
    #cloud-search-results .sxt-search-price-v82 .sxt-search-market-value-v82 {text-decoration:line-through!important}
    #predictive-search-results-products-list .predictive-search__item {
      display:flex!important;flex-direction:column!important;align-items:stretch!important;
      gap:12px!important;padding:0!important;height:100%;text-decoration:none;
    }
    #predictive-search-results-products-list .predictive-search__image,
    #predictive-search-results-products-list .predictive-search__image .media {
      display:block!important;width:100%!important;height:250px!important;margin:0!important;padding:0!important;
    }
    #predictive-search-results-products-list img {width:100%!important;height:100%!important;object-fit:contain!important}
    #predictive-search-results-products-list .predictive-search__item-content {width:100%!important;min-width:0;text-align:center!important}
    #predictive-search-results-products-list .predictive-search__item-heading {font-size:12px!important;line-height:1.4!important;letter-spacing:.03em;text-transform:uppercase;overflow-wrap:anywhere}
    #predictive-search-results-products-list .sxt-price-grid {display:flex!important;flex-direction:column!important;align-items:center!important;gap:4px!important}
    #predictive-search-results-products-list .sxt-current-grid {font-size:16px!important;font-weight:700!important;color:#171717!important}
    #predictive-search-results-products-list .sxt-price-reference,
    #predictive-search-results-products-list .sxt-price-reference * {font-size:10px!important;line-height:1.5!important}
    :is(#cloud-search-results,#predictive-search-results-products-list) :is(.sxt-card-availability,.sxt-v8-variants,.sxt-card-stock-badge,.cs-inventory,.cs-stock,.cs-availability,.cs-sizes,[data-sxt-stock],[data-sxt-sizes]),
    :is(.template-search,.sxt-search-page) :is(.card-wrapper,.cloud-search-filters-products) :is(.sxt-card-availability,.sxt-v8-variants,.sxt-card-stock-badge,.cs-inventory,.cs-stock,.cs-availability,.cs-sizes) {display:none!important}
    @media(max-width:359px) {
      #cloud-search-results .sxt-search-grid-v82,#predictive-search-results-products-list {gap:18px 8px!important;padding:12px!important}
      #cloud-search-results .sxt-search-card-v82 img,#cloud-search-results .sxt-search-card-v82 .sxt-search-media-v82 {height:220px!important}
    }
  `;
  (document.head || document.documentElement).append(style);

  function prices(root) {
    root.querySelectorAll('.cs-price-block, .details-top-text').forEach(block => {
      const current = block.querySelector('.cs-has-list-price')
        || [...block.querySelectorAll('.price')].find(node => !node.classList.contains('cs-list-price'));
      if (!current) return;
      const market = block.querySelector('.cs-list-price, .compare-at-price, del, s');
      const oldNow = block.querySelector('.sxt-search-now-v82');
      const oldMarket = block.querySelector('.sxt-search-market-v82');
      if (oldNow?.contains(current) && (!market || oldMarket?.contains(market))) return;
      const now = document.createElement('div'); now.className = 'sxt-search-now-v82';
      const preserveDetails = block.matches('.details-top-text') && !block.matches('.cs-price-block');
      if (preserveDetails) current.before(now);
      now.append(current);
      const children = [now];
      if (market && market !== current && !market.contains(current)) {
        const reference = document.createElement('div'); reference.className='sxt-search-market-v82';
        const label = document.createElement('span');
        label.textContent = document.documentElement.lang.toLowerCase().startsWith('en') ? 'Market price ' : 'Пазарна цена ';
        market.classList.add('sxt-search-market-value-v82');
        if (preserveDetails) market.before(reference);
        reference.append(label,market);children.push(reference);
      }
      block.classList.add('sxt-search-price-v82');
      if (!preserveDetails) block.replaceChildren(...children);
    });
  }

  function emphasizeBrand(link) {
    if (link.querySelector('.sxt-search-brand-v87')) return;
    const title = link.textContent.trim();
    const separator = title.indexOf(' - ');
    const brand = (separator < 0 ? title : title.slice(0, separator)).trim();
    if (!brand) return;
    if (!link.hasAttribute('aria-label')) link.setAttribute('aria-label',title);
    const strong = document.createElement('strong');
    strong.className = 'sxt-search-brand-v87';strong.textContent = brand;
    link.replaceChildren(strong);
  }
  let queued = false;
  function enhance() {
    queued = false;
    document.querySelectorAll('#cloud-search-results').forEach(root => {
      root.querySelectorAll('.cs-item').forEach(item => {
        const productLink = item.matches('a[href*="/products/"]') ? item : item.querySelector('a[href*="/products/"]');
        if (!productLink) return;
        item.classList.add('sxt-search-card-v82');
        item.parentElement?.classList.add('sxt-search-grid-v82');
        const image = item.querySelector('img');
        const media = image?.closest('.cs-item-image, .cs-image, .cs-product-image') || image?.parentElement;
        if (media && media !== item && !media.querySelector('.cs-item-details, .cs-price-block')) media.classList.add('sxt-search-media-v82');
      });
      prices(root);
      root.querySelectorAll('.sxt-search-card-v82').forEach(item => {
        item.querySelectorAll('.sxt-search-media-v82').forEach(node => node.style.setProperty('order', '0', 'important'));
        item.querySelectorAll('.cs-item-details').forEach(node => node.style.setProperty('order', '1', 'important'));
        item.querySelectorAll('.cs-price-block').forEach(node => node.style.setProperty('order', '2', 'important'));
        item.querySelectorAll('.cs-product-link, [id^="cloud-search-option-"][id$="-name"]').forEach(emphasizeBrand);
      });
    });
  }
  function schedule() {
    if (queued) return;
    queued=true;requestAnimationFrame(enhance);
  }
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,characterData:true});
  document.addEventListener('cloud-search:render',schedule);
  document.addEventListener('DOMContentLoaded',schedule,{once:true});
  schedule();
})();

/* V83 filter rail shared by collection/search and mobile/desktop. */
(() => {
  if (window.SXTFilterControlsV83) return;
  window.SXTFilterControlsV83 = true;
  const style = document.createElement('style');
  style.id = 'sxt-filter-controls-v83';
  style.textContent = `
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls {
      display:block!important;width:100%!important;height:auto!important;box-sizing:border-box!important;
      margin:0!important;padding:14px 0!important;background:#fff!important;
      border-top:1px solid #e4e1db!important;border-bottom:1px solid #e4e1db!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters-container {
      display:block!important;width:100%!important;max-width:100%!important;height:auto!important;overflow:visible!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters {
      display:flex!important;align-items:center!important;flex-flow:row wrap!important;
      gap:9px!important;width:100%!important;max-width:100%!important;min-width:0!important;
      height:auto!important;margin:0!important;padding:0 16px!important;box-sizing:border-box!important;overflow:visible!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters > .cloud-search-filter {
      flex:0 0 auto!important;width:auto!important;min-width:0!important;margin:0!important;padding:0!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter__name,
    #cloud_search_filters_root.sxt-filter-layout-v83 :is(.sxt-app-sortbar--chip,.sxt-native-sort-v83) select {
      display:inline-flex!important;align-items:center!important;justify-content:center!important;
      width:auto!important;min-width:88px!important;max-width:260px!important;height:50px!important;
      margin:0!important;padding:0 15px!important;box-sizing:border-box!important;
      border:1px solid #111!important;border-radius:1px!important;background:#fff!important;
      color:#111!important;box-shadow:none!important;cursor:pointer;
      font:600 12px/1.2 var(--font-body-family,Arial,sans-serif)!important;letter-spacing:.02em!important;text-transform:none!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter--active .cloud-search-filter__name {
      border-color:#660033!important;background:linear-gradient(#fff calc(100% - 3px),#660033 0)!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter--open .cloud-search-filter__name {
      border-color:#000!important;background:#000!important;color:#fff!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter__name::after {border-color:currentColor!important}
    #cloud_search_filters_root.sxt-filter-layout-v83 :is(.sxt-app-sortbar--chip,.sxt-native-sort-v83) {
      position:relative!important;display:block!important;flex:0 0 auto!important;order:10000!important;
      width:auto!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 :is(.sxt-app-sortbar--chip,.sxt-native-sort-v83) label {
      position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;
      overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 :is(.sxt-app-sortbar--chip,.sxt-native-sort-v83) select {
      appearance:none!important;min-width:160px!important;padding-right:38px!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 :is(.sxt-app-sortbar--chip,.sxt-native-sort-v83)::after {
      content:''!important;position:absolute!important;right:15px!important;top:50%!important;
      width:7px!important;height:7px!important;border:solid #111!important;border-width:0 2px 2px 0!important;
      transform:translateY(-70%) rotate(45deg)!important;pointer-events:none!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .sxt-filter-search-control,
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters-link {display:none!important}
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filters-sidebar-container {display:block!important}
    #cloud_search_filters_root.sxt-filter-layout-v83 #cloud_search_filters_sidebar:not(.sxt-filter-sidebar-inline-v83) {display:none!important}
    #cloud_search_filters_root.sxt-filter-layout-v83 #cloud_search_filters_sidebar.sxt-filter-sidebar-inline-v83 {
      position:static!important;width:100%!important;max-width:none!important;height:auto!important;border:0!important;overflow:visible!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filters-products {width:100%!important;max-width:none!important;min-width:0!important;padding-left:0!important}
    :is(#cloud_search_filters_root,.cloud-search-filter-values-container) .sxt-filter-apply-v83,
    .cloud-search-filter-values-container.sxt-filter-apply-v83 {
      display:flex!important;align-items:center!important;justify-content:center!important;
      min-height:46px!important;padding:12px 18px!important;box-sizing:border-box!important;
      border:1px solid #000!important;border-radius:0!important;background:#000!important;background-image:none!important;
      color:#fff!important;-webkit-text-fill-color:#fff!important;text-decoration:none!important;box-shadow:none!important;
      font:600 14px/1.3 var(--font-body-family,Arial,sans-serif)!important;letter-spacing:.02em!important;
    }
    .sxt-filter-apply-v83 * {color:#fff!important;-webkit-text-fill-color:#fff!important}
    .sxt-filter-apply-v83:disabled {opacity:.45!important;cursor:not-allowed!important}
    @media(max-width:749px) {
      #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters {
        flex-wrap:nowrap!important;overflow-x:auto!important;overflow-y:hidden!important;
        padding-bottom:3px!important;scroll-padding-inline:16px;scroll-snap-type:none!important;scroll-behavior:auto!important;scrollbar-width:none!important;-webkit-overflow-scrolling:touch;
      }
      #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters::-webkit-scrollbar {display:none!important}
      #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters > * {scroll-snap-align:start}
    }
  `;
  (document.head || document.documentElement).append(style);
  function emphasizeBrand(link) {
    if (link.querySelector('.sxt-search-brand-v87')) return;
    const title = link.textContent.trim();
    const separator = title.indexOf(' - ');
    const brand = (separator < 0 ? title : title.slice(0, separator)).trim();
    if (!brand) return;
    if (!link.hasAttribute('aria-label')) link.setAttribute('aria-label',title);
    const strong = document.createElement('strong');
    strong.className = 'sxt-search-brand-v87';strong.textContent = brand;
    link.replaceChildren(strong);
  }
  let queued = false;
  const applyButtons = () => {
    queued = false;
    document.querySelectorAll('#cloud_search_filters_root,.cloud-search-filter-values-container').forEach(scope => {
      scope.querySelectorAll('button,a,[role="button"],input[type="submit"],.cloudsearch-filters-submit').forEach(button => {
        const text = (button.tagName==='INPUT' ? button.value : button.textContent).replace(/\s+/g,' ').trim();
        if (/^(покажи(?:\s|$)|show\s+\d|apply\b|приложи(?:\s|$))/iu.test(text) && !/^(покажи\s+още|show\s+more)/iu.test(text)) button.classList.add('sxt-filter-apply-v83');
      });
    });
  };
  const schedule = () => {if (!queued) {queued=true;requestAnimationFrame(applyButtons);}};
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,characterData:true});
  document.addEventListener('cloud-search:render',schedule);
  schedule();
})();

/* SXT V86: compact reference amounts, keep the selling price dominant. */
(() => {
  if (document.getElementById('sxt-search-prices-v86')) return;
  const style = document.createElement('style');
  style.id = 'sxt-search-prices-v86';
  style.textContent = `
    #cloud-search-results .sxt-search-price-v82 .sxt-search-market-v82 .cs-list-price,
    #cloud-search-results .sxt-search-price-v82 .sxt-search-market-value-v82,
    #predictive-search-results-products-list .sxt-price-grid .sxt-price-reference s {
      font-size:11px!important;line-height:1.5!important;
    }
    #predictive-search-results-products-list .sxt-price-grid .sxt-current-grid,
    #predictive-search-results-products-list .sxt-price-grid .sxt-current-grid * {
      font-size:16px!important;font-weight:700!important;line-height:1.25!important;
    }
  `;
  document.head.appendChild(style);
})();

/* SXT V87: brand and product name precede the price. */
(() => {
  if (document.getElementById('sxt-search-brand-v87-style')) return;
  const style = document.createElement('style');
  style.id = 'sxt-search-brand-v87-style';
  style.textContent = `
    #cloud-search-results .sxt-search-card-v82 .sxt-search-brand-v87 {
      font-size:inherit!important;font-weight:700!important;line-height:inherit!important;
    }
    #cloud-search-results .sxt-search-card-v82 .cs-product-link,
    #cloud-search-results .sxt-search-card-v82 [id^="cloud-search-option-"][id$="-name"] {order:0!important}
    #cloud-search-results .sxt-search-card-v82 .sxt-search-now-v82 {order:1!important}
    #cloud-search-results .sxt-search-card-v82 .sxt-search-market-v82 {order:2!important}
    #predictive-search-results-products-list .predictive-search__item-vendor {font-weight:700!important}
    #predictive-search-results-products-list .sxt-search-brand-v87 {font-weight:700!important;font-size:inherit!important}
  `;
  document.head.appendChild(style);
})();
/* SXT V88: visible filter scroller, native reset action and readable states. */
(() => {
  if (document.getElementById('sxt-filter-controls-v88')) return;
  const style = document.createElement('style');
  style.id = 'sxt-filter-controls-v88';
  style.textContent = `
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls .cloud-search-filter .cloud-search-filter__name,
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls .cloud-search-filter .cloud-search-filter__name * {
      color:#111!important;-webkit-text-fill-color:#111!important;opacity:1!important;visibility:visible!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter.cloud-search-filter--active .cloud-search-filter__name,
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter.cloud-search-filter--open .cloud-search-filter__name {
      background:#f5eaf0!important;border-color:#660033!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .sxt-filter-reset-v88 {
      display:inline-flex!important;align-items:center!important;justify-content:center!important;
      flex:0 0 auto!important;order:-1!important;width:auto!important;min-width:76px!important;height:50px!important;
      box-sizing:border-box!important;margin:0!important;padding:0 14px!important;
      background:#660033!important;border:1px solid #660033!important;border-radius:1px!important;
      color:#111!important;-webkit-text-fill-color:#111!important;text-decoration:none!important;
      font:700 12px/1.2 var(--font-body-family,Arial,sans-serif)!important;letter-spacing:.05em!important;
      white-space:nowrap!important;cursor:pointer!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .sxt-filter-reset-v88 * {color:#111!important;-webkit-text-fill-color:#111!important}
    #cloud_search_filters_root .sxt-filter-scroll-v88 {
      display:block!important;appearance:none!important;-webkit-appearance:none!important;
      width:calc(100% - 32px)!important;max-width:100%!important;height:18px!important;
      margin:8px 16px 0!important;padding:0!important;background:transparent!important;border:0!important;
      cursor:ew-resize!important;box-shadow:none!important;touch-action:pan-y;
    }
    #cloud_search_filters_root .sxt-filter-scroll-v88[hidden] {display:none!important}
    #cloud_search_filters_root .sxt-filter-scroll-v88::-webkit-slider-runnable-track {height:3px;background:#e2ded3;border-radius:3px}
    #cloud_search_filters_root .sxt-filter-scroll-v88::-webkit-slider-thumb {
      appearance:none;-webkit-appearance:none;width:52px;height:9px;margin-top:-3px;border:0;border-radius:8px;background:#660033;
    }
    #cloud_search_filters_root .sxt-filter-scroll-v88::-moz-range-track {height:3px;background:#e2ded3;border-radius:3px}
    #cloud_search_filters_root .sxt-filter-scroll-v88::-moz-range-thumb {width:52px;height:9px;border:0;border-radius:8px;background:#660033}
    #cloud_search_filters_root .sxt-filter-scroll-v88:focus-visible {outline:2px solid #111;outline-offset:2px}
    @media(max-width:749px) {
      #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters > .sxt-filter-reset-v88 {flex-shrink:0!important}
    }
  `;
  (document.head || document.documentElement).append(style);
  const bound = new WeakSet();
  const clean = text => String(text || '').replace(/\s+/g,' ').trim();
  let queued = false;
  function enhance() {
    queued = false;
    document.querySelectorAll('#cloud_search_filters_root .cloud-search-page-controls').forEach(controls => {
      (controls.closest('#cloud_search_filters_root') || controls).querySelectorAll('a,button,input[type="reset"],[role="button"],span,div').forEach(node => {
        if (!node.matches('a,button,input,[role="button"]') && node.children.length) return;
        const text = clean(node.matches('input') ? node.value : node.textContent);
        if (!node.classList.contains('sxt-filter-reset-v88') && !/^(изчисти всички филтри|изчисти филтрите|clear all(?: filters)?|reset(?: all)?(?: filters)?)$/i.test(text)) return;
        node.classList.add('sxt-filter-reset-v88');
        if (text !== 'RESET') {
          if (node.matches('input')) node.value = 'RESET';
          else node.textContent = 'RESET';
        }
        if (node.getAttribute('aria-label') !== 'Изчисти всички филтри') node.setAttribute('aria-label','Изчисти всички филтри');
      });
      const rail = controls.querySelector('.cloud-search-page-controls__filters');
      if (!rail) return;
      let slider = controls.querySelector('.sxt-filter-scroll-v88');
      if (!slider) {
        slider = document.createElement('input');
        slider.type = 'range';slider.min = '0';slider.step = '1';slider.value = '0';
        slider.className = 'sxt-filter-scroll-v88';
        slider.setAttribute('aria-label','Превърти филтрите');
      }
      if (slider.previousElementSibling !== rail) rail.after(slider);
      const sync = () => {
        if (!rail.isConnected || !slider.isConnected) return;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        slider.max = String(max);slider.hidden = max < 2;
        if (!slider.sxtScrollAnimating) slider.value = String(Math.max(0,Math.min(max,rail.scrollLeft)));
      };
      if (!bound.has(rail)) {
        bound.add(rail);
        let frame = 0, target = 0, lastTime = 0;
        const stop = () => {
          cancelAnimationFrame(frame);frame=0;lastTime=0;
          slider.sxtScrollAnimating=false;sync();
        };
        const glide = time => {
          if (!rail.isConnected || !slider.isConnected) {stop();return;}
          target=Math.max(0,Math.min(target,rail.scrollWidth-rail.clientWidth));
          const delta=target-rail.scrollLeft;
          const dt=lastTime?Math.min(time-lastTime,50):16.67;lastTime=time;
          if(Math.abs(delta)<3){rail.scrollLeft=target;stop();return;}
          rail.scrollLeft+=delta*(1-Math.exp(-dt/65));
          frame=requestAnimationFrame(glide);
        };
        slider.addEventListener('input',event => {
          event.stopPropagation();target=Number(slider.value);
          if(matchMedia('(prefers-reduced-motion: reduce)').matches){rail.scrollLeft=target;return;}
          slider.sxtScrollAnimating=true;
          if(!frame)frame=requestAnimationFrame(glide);
        });
        rail.addEventListener('pointerdown',stop,{passive:true});
        rail.addEventListener('touchstart',stop,{passive:true});
        rail.addEventListener('wheel',stop,{passive:true});
        slider.addEventListener('change',event => event.stopPropagation());
        rail.addEventListener('scroll',sync,{passive:true});
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => {
            if (!rail.isConnected) {observer.disconnect();return;}
            sync();
          });
          observer.observe(rail);
        }
      }
      sync();
    });
  }
  function schedule() {if (!queued) {queued=true;requestAnimationFrame(enhance);}}
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,characterData:true});
  document.addEventListener('cloud-search:render',schedule);
  document.addEventListener('DOMContentLoaded',schedule,{once:true});
  window.addEventListener('resize',schedule,{passive:true});
  schedule();
})();


/* V89: the sidebar is a sibling of the products, outside the app root. */
(() => {
  if(document.getElementById('sxt-sidebar-v89')) return;
  const style=document.createElement('style');style.id='sxt-sidebar-v89';
  style.textContent=`
    body:has(#cloud_search_filters_root) #cloud_search_filters_sidebar {
      display:none!important;width:0!important;min-width:0!important;max-width:0!important;
      flex:0 0 0!important;margin:0!important;padding:0!important;border:0!important;
    }
    body:has(#cloud_search_filters_root) .cloud-search-filters-sidebar-container {
      display:block!important;width:100%!important;max-width:100%!important;
    }
    body:has(#cloud_search_filters_root) .cloud-search-filters-sidebar-container > .cloud-search-filters-products {
      width:100%!important;max-width:100%!important;min-width:0!important;
      margin-inline:0!important;padding-left:0!important;flex:1 1 100%!important;
    }
    body:has(#cloud_search_filters_root) .section--padding.page-width {
      padding-left:var(--page-padding,16px)!important;
    }
  `;
  document.head.appendChild(style);
})();


/* V91: readable RESET on Burgundy. */
(() => {
  if(document.getElementById('sxt-burgundy-v91')) return;
  const style=document.createElement('style');style.id='sxt-burgundy-v91';
  style.textContent=`
    #cloud_search_filters_root.sxt-filter-layout-v83 .sxt-filter-reset-v88,
    #cloud_search_filters_root.sxt-filter-layout-v83 .sxt-filter-reset-v88 * {
      color:#fff!important;-webkit-text-fill-color:#fff!important;
    }
  `;
  document.head.appendChild(style);
})();

/* V93: search cards show only the brand and current price. */
(() => {
  if(document.getElementById('sxt-search-simple-v93')) return;
  const style=document.createElement('style');style.id='sxt-search-simple-v93';
  style.textContent=`
    #cloud-search-results .sxt-search-price-v82 .sxt-search-market-v82,
    #cloud-search-results .sxt-search-card-v82 :is(.cs-product-type,.cs-description,.cs-discount),
    #predictive-search-results-products-list :is(.sxt-price-reference,.sxt-price-now__label,.sxt-price-lowest) {display:none!important}
    #predictive-search-results-products-list .predictive-search__item-heading strong {font-size:12px!important;font-weight:700!important}
    @media(max-width:749px) {
      #predictive-search-results-products-list .predictive-search__image,
      #predictive-search-results-products-list .predictive-search__image .media {height:220px!important}
    }
  `;
  document.head.appendChild(style);
})();

/* V95: remove thumbnail limits on the actual image, not only its frame. */
(() => {
  if(document.getElementById('sxt-search-images-v95')) return;
  const style=document.createElement('style');style.id='sxt-search-images-v95';
  style.textContent=`
    #cloud-search-results .sxt-search-card-v82 .sxt-search-media-v82,
    #cloud-search-results .sxt-search-card-v82 :is(.cs-item-image,.cs-image,.cs-product-image),
    #predictive-search-results-products-list .predictive-search__image,
    #predictive-search-results-products-list .predictive-search__image .media {
      display:block!important;box-sizing:border-box!important;
      width:100%!important;max-width:none!important;min-width:0!important;
      height:240px!important;max-height:none!important;min-height:0!important;
      padding:0!important;margin:0!important;flex:0 0 auto!important;
    }
    #cloud-search-results .sxt-search-card-v82 img,
    #predictive-search-results-products-list .predictive-search__image img {
      display:block!important;position:static!important;inset:auto!important;
      box-sizing:border-box!important;width:100%!important;height:240px!important;
      max-width:none!important;max-height:none!important;min-width:0!important;min-height:0!important;
      padding:0!important;margin:0 auto!important;aspect-ratio:auto!important;
      object-fit:contain!important;object-position:center!important;transform:none!important;
    }
    #cloud-search-results .sxt-search-card-v82 picture {display:block!important;width:100%!important;max-width:none!important;max-height:none!important}
    @media(min-width:750px) {
      #cloud-search-results .sxt-search-card-v82 .sxt-search-media-v82,
      #cloud-search-results .sxt-search-card-v82 :is(.cs-item-image,.cs-image,.cs-product-image),
      #cloud-search-results .sxt-search-card-v82 img,
      #predictive-search-results-products-list .predictive-search__image,
      #predictive-search-results-products-list .predictive-search__image .media,
      #predictive-search-results-products-list .predictive-search__image img {height:270px!important}
    }
  `;
  document.head.appendChild(style);
})();

/* V102: contain multi-selection labels without changing provider controls. */
(() => {
  if (document.getElementById('sxt-filter-overflow-v102')) return;
  const style = document.createElement('style');
  style.id = 'sxt-filter-overflow-v102';
  style.textContent = `
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters > .cloud-search-filter {
      flex:0 0 auto!important;max-width:220px!important;min-width:0!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter__name {
      position:relative!important;display:block!important;
      max-width:220px!important;min-width:88px!important;
      overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important;
      text-align:left!important;line-height:48px!important;padding:0 36px 0 15px!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter__name > :not(svg) {
      position:static!important;display:inline!important;float:none!important;
      white-space:nowrap!important;line-height:inherit!important;
    }
    #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter__name::after {
      position:absolute!important;right:14px!important;top:50%!important;
      margin:0!important;transform:translateY(-70%) rotate(45deg)!important;
    }
    @media(max-width:749px) {
      #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-page-controls__filters > .cloud-search-filter,
      #cloud_search_filters_root.sxt-filter-layout-v83 .cloud-search-filter__name {max-width:190px!important}
    }
  `;
  document.head.appendChild(style);
})();

/* V108: observe native expanded state, including reused panels. */
(() => {
  if(window.sxtFilterMotionV108)return;window.sxtFilterMotionV108=true;
  const selector='.cloud-search-filter-values-container';
  const active=new Map(), ghosts=new Set();
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const duration=560, easing='cubic-bezier(.25,.8,.25,1)';
  const style=document.createElement('style');
  style.textContent='.sxt-filter-close-v108{display:flex!important;align-items:center!important;justify-content:center!important;width:48px!important;height:38px!important;padding:0!important;margin:0 auto 12px!important;border:0!important;background:transparent!important;color:#660033!important;cursor:pointer}.sxt-filter-close-v108::before{content:"";width:10px;height:10px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg)}.sxt-filter-close-v108:focus-visible{outline:2px solid #660033}';
  document.head.append(style);
  style.textContent += '.cloud-search-filter-values-container.sxt-filter-closed-v109:not([data-sxt-motion-ghost]){display:none!important;visibility:hidden!important;pointer-events:none!important}';
  function controlFor(panel){
    const content=panel.querySelector('[id]');
    return [...document.querySelectorAll('#cloud_search_filters_root [role="button"][aria-expanded]')].find(c=>
      (content&&c.getAttribute('aria-controls')===content.id)||c.dataset.filterName===panel.dataset.filterName);
  }
  function snapshot(panel,state){
    const rect=panel.getBoundingClientRect();
    if(rect.width&&rect.height){state.rect=rect;state.copy=panel.cloneNode(true)}
  }
  function leave(panel,state){
    active.delete(panel);state.animation?.cancel();
    if(reduced()||!state.copy)return;
    const ghost=state.copy;ghost.dataset.sxtMotionGhost='true';ghost.inert=true;ghost.setAttribute('aria-hidden','true');
    ghost.removeAttribute('id');ghost.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));
    const r=state.rect;
    Object.entries({position:'fixed',top:r.top+'px',left:r.left+'px',right:'auto',bottom:'auto',width:r.width+'px',height:r.height+'px',margin:'0',transform:'none',display:'block',visibility:'visible','pointer-events':'none','z-index':'9999',overflow:'hidden'}).forEach(([k,v])=>ghost.style.setProperty(k,v,'important'));
    document.body.append(ghost);ghosts.add(ghost);
    const animation=ghost.animate([{translate:'0 0',opacity:1},{translate:'0 65px',opacity:0}],{duration,easing});
    const clean=()=>{ghost.remove();ghosts.delete(ghost)};
    animation.finished.catch(()=>{}).finally(clean);setTimeout(clean,duration+100);
  }
  function scan(){
    for(const [panel,state] of active){
      const control=controlFor(panel);
      if(!panel.isConnected||!control||control.getAttribute('aria-expanded')!=='true'||!panel.getClientRects().length||getComputedStyle(panel).visibility==='hidden')leave(panel,state);
    }
    document.querySelectorAll(selector).forEach(panel=>{
      if(panel.dataset.sxtMotionGhost)return;
      const control=controlFor(panel);
      const expanded=!!control&&control.getAttribute('aria-expanded')==='true';
      if(!expanded){
        if(!panel.classList.contains('sxt-filter-closed-v109'))panel.classList.add('sxt-filter-closed-v109');
        panel.querySelectorAll('.sxt-filter-close-v108').forEach(button=>button.remove());
        return;
      }
      if(panel.classList.contains('sxt-filter-closed-v109'))panel.classList.remove('sxt-filter-closed-v109');
      if(!control||control.getAttribute('aria-expanded')!=='true'||!panel.getClientRects().length||getComputedStyle(panel).visibility==='hidden')return;
      if(!panel.querySelector('.sxt-filter-close-v108')){
        const button=document.createElement('button');button.type='button';button.className='sxt-filter-close-v108';button.setAttribute('aria-label',document.documentElement.lang.startsWith('en')?'Close filter':'Затвори филтъра');
        button.onclick=event=>{event.preventDefault();event.stopPropagation();const trigger=controlFor(panel);if(trigger?.getAttribute('aria-expanded')==='true'){trigger.click();trigger.focus({preventScroll:true})}};
        panel.prepend(button);
      }
      if(!active.has(panel)){
        ghosts.forEach(g=>g.remove());ghosts.clear();
        const state={};active.set(panel,state);snapshot(panel,state);
        if(!reduced()){
          state.animation=panel.animate([{translate:'0 65px',opacity:0},{translate:'0 0',opacity:1}],{duration,easing});
          state.animation.finished.then(()=>{if(active.get(panel)===state)snapshot(panel,state)}).catch(()=>{});
        }
      }else if(!active.get(panel).animation||active.get(panel).animation.playState!=='running')snapshot(panel,active.get(panel));
    });
  }
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-expanded','class','style','hidden']});
  addEventListener('scroll',()=>active.forEach((s,p)=>snapshot(p,s)),{passive:true});
  addEventListener('resize',()=>active.forEach((s,p)=>snapshot(p,s)));
  scan();
})();

/* V121: search layout follows the open dialog, not Sheen's transient body flag. */
(() => {
  if(window.sxtSearchSurfaceV116)return;window.sxtSearchSurfaceV116=true;
  const style=document.createElement('style');style.id='sxt-search-surface-v116';
  style.textContent=`
    body.sxt-search-open-v121 .header-wrapper {z-index:10010!important}
    body.sxt-search-open-v121 .search-modal {
      position:fixed!important;inset:0!important;width:100%!important;height:100dvh!important;
      max-height:none!important;box-sizing:border-box!important;padding:28px 24px!important;
      background:#fff!important;z-index:10011!important;overflow:auto!important;transform:none!important;
    }
    body.sxt-search-open-v121 .search-modal>.page-width,
    body.sxt-search-open-v121 .search-modal__content,
    body.sxt-search-open-v121 .search-modal__form {height:auto!important;min-height:0!important}
    body.sxt-search-open-v121 .search-modal>.page-width {padding:0!important;max-width:1400px!important;margin:auto!important}
    body.sxt-search-open-v121 .search-modal__content {max-width:none!important}
    body.sxt-search-open-v121 .search-modal .modal-overlay {display:none!important}
    body.sxt-search-open-v121 .sxt-search-modal-heading {margin:0 0 22px!important}
    body.sxt-search-open-v121 .sxt-search-modal-heading h2 {font-size:32px!important;line-height:1.15!important;margin:10px 0!important}
    body.sxt-search-open-v121 .sxt-search-modal-heading p {font-size:13px!important;margin:0!important}
    body.sxt-search-open-v121 .search-modal .field {background:#f5f5f5!important;border-bottom:1px solid #660033!important}
    body.sxt-search-open-v121 .search-modal .search__input {font-size:20px!important}
    body.sxt-search-open-v121.sxt-search-has-query-v116 .sxt-search-shortcuts {display:none!important}
    #cloud-search-results {
      position:fixed!important;inset:auto!important;top:var(--sxt-search-top-v116,220px)!important;
      left:var(--sxt-search-left-v116,24px)!important;width:var(--sxt-search-width-v116,calc(100vw - 48px))!important;
      max-width:none!important;transform:none!important;margin:0!important;background:#fff!important;
      z-index:10020!important;border:0!important;box-shadow:none!important;box-sizing:border-box!important;
    }
    body.sxt-search-open-v121 #cloud-search-results .cloud-search-results__scroll {
      max-height:calc(100dvh - var(--sxt-search-top-v116,220px) - 16px)!important;
      overflow:auto!important;overscroll-behavior:contain;
    }
    body.sxt-cloud-mobile-v117 .cloud-search-mobile-backdrop {background:#fff!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important}
    body.sxt-cloud-mobile-v117 .cloud-search-mobile {background:#fff!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important}
    body.sxt-cloud-mobile-v117 #cloud-search-results {
      z-index:2147483647!important;position:fixed!important;transform:none!important;
      inset:auto!important;top:var(--sxt-search-top-v116,64px)!important;
      left:0!important;width:100%!important;max-width:100%!important;margin:0!important;
      background:#fff!important;filter:none!important;backdrop-filter:none!important;
    }
    body.sxt-cloud-mobile-v117 #cloud-search-results .cloud-search-results__scroll {
      max-height:calc(var(--sxt-search-viewport-v117,100dvh) - var(--sxt-search-top-v116,64px) - 8px)!important;
      overflow:auto!important;overscroll-behavior:contain;
    }
    #cloud-search-results dl.sxt-search-grid-v82>dd {display:none!important}
    #cloud-search-results .sxt-search-grid-v82 {grid-template-columns:repeat(4,minmax(0,1fr))!important}
    #cloud-search-results .sxt-search-card-v82 {min-width:0!important;width:100%!important}
    #cloud-search-results .sxt-search-inline-price-v116 {
      display:block!important;order:2!important;text-align:center!important;margin:10px 0 0!important;
      color:#171717!important;font-size:16px!important;font-weight:700!important;line-height:1.4!important;
      background:none!important;text-decoration:underline solid #660033!important;text-decoration-thickness:1px!important;text-underline-offset:3px!important;
    }
    #cloud-search-results .sxt-search-card-v82:has(.sxt-search-inline-price-v116)>.sxt-search-price-v82 {display:none!important}
    @media(max-width:749px){
      body.sxt-search-open-v121 .search-modal {padding:18px 14px!important}
      body.sxt-search-open-v121 .sxt-search-modal-heading h2 {font-size:25px!important}
      #cloud-search-results .sxt-search-grid-v82 {grid-template-columns:repeat(2,minmax(0,1fr))!important}
    }
    /* V120: target provider structure too, before enhancement after a re-render. */
    html body #cloud-search-results .block-products > dl {display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:10px!important;padding:12px!important;width:100%!important;margin:0!important}
    html body #cloud-search-results .block-products > dl > dt.cs-item {display:flex!important;flex-direction:column!important;grid-column:auto!important;grid-row:auto!important;float:none!important;position:relative!important;width:100%!important;min-width:0!important;max-width:none!important;box-sizing:border-box!important;border:1px solid #e5e1e3!important;background:#fff!important}
    html body #cloud-search-results .block-products > dl > dd {display:none!important}
    html body #cloud-search-results .see-more-results {display:none!important}
    #cloud-search-results .sxt-search-brands-v120 {display:flex!important;align-items:center;justify-content:center;min-height:46px;margin:4px 12px 10px;padding:12px 18px;box-sizing:border-box;background:#fff!important;border:1px solid #660033;color:#660033!important;font-size:13px;font-weight:600;text-align:center;text-decoration:none!important}
    #cloud-search-results .sxt-search-brands-v120:hover {background:#660033!important;color:#fff!important}
    #cloud-search-results .sxt-search-brands-v120:focus-visible {outline:2px solid #660033;outline-offset:3px}
    @media(max-width:749px){html body #cloud-search-results .block-products > dl {grid-template-columns:repeat(2,minmax(0,1fr))!important}}
    /* V118: compact bordered cells and a full-results action. */
    #cloud-search-results .sxt-search-grid-v82 {gap:10px!important;padding:12px!important;align-items:stretch!important}
    #cloud-search-results .sxt-search-card-v82 {box-sizing:border-box!important;border:1px solid #e5e1e3!important;padding:10px 8px 14px!important;gap:6px!important;justify-content:flex-start!important}
    #cloud-search-results .sxt-search-card-v82 .sxt-search-media-v82,
    #cloud-search-results .sxt-search-card-v82 :is(.cs-item-image,.cs-image,.cs-product-image),
    #cloud-search-results .sxt-search-card-v82 img {height:200px!important}
    #cloud-search-results .sxt-search-inline-price-v116 {margin:2px 0 0!important}
    #cloud-search-results .sxt-search-all-v118 {display:flex!important;align-items:center;justify-content:center;box-sizing:border-box;min-height:46px;margin:4px 12px 16px;padding:12px 18px;background:#660033!important;color:#fff!important;border:1px solid #660033;font-family:inherit;font-weight:600;font-size:13px;line-height:1.4;text-align:center;text-decoration:none!important;letter-spacing:.02em}
    #cloud-search-results .sxt-search-all-v118:hover {background:#4d0026!important}
    #cloud-search-results .sxt-search-all-v118:focus-visible {outline:2px solid #660033;outline-offset:3px}
    #cloud-search-results .sxt-search-all-v118[hidden] {display:none!important}
    @media(max-width:749px){
      #cloud-search-results .sxt-search-card-v82 .sxt-search-media-v82,
      #cloud-search-results .sxt-search-card-v82 :is(.cs-item-image,.cs-image,.cs-product-image),
      #cloud-search-results .sxt-search-card-v82 img {height:160px!important}
    }
    body.sxt-search-open-v121 {overflow:hidden!important}
    body.sxt-search-open-v121 .header-wrapper,
    body.sxt-search-open-v121 .shopify-section-header,
    body.sxt-search-open-v121 .transition-content {transform:none!important;filter:none!important;backdrop-filter:none!important}
    body.sxt-search-open-v121 .search-modal {opacity:1!important;visibility:visible!important;overflow:hidden!important}
    .sxt-search-shortcuts a,.sxt-search-shortcuts a:hover,.sxt-search-shortcuts a:focus {text-decoration:none!important;background-image:none!important;box-shadow:none!important;text-shadow:none!important;border:0!important;border-radius:0!important;display:inline-flex!important;align-items:center!important;line-height:1.4!important;height:auto!important;background:transparent!important}
    .sxt-search-shortcuts a::before,.sxt-search-shortcuts a::after {display:none!important}
    #cloud-search-results {filter:none!important;backdrop-filter:none!important;border:0!important;box-shadow:none!important}
    #cloud-search-results .cloud-search-results__scroll {min-height:0!important;height:auto!important;padding-bottom:16px!important;overscroll-behavior:contain;touch-action:pan-y;-webkit-overflow-scrolling:touch}
  `;document.head.append(style);
  let queued=false;
  const setStyle=(node,key,value)=>{
    if(node.style.getPropertyValue(key)!==value||node.style.getPropertyPriority(key)!=='important')node.style.setProperty(key,value,'important');
  };
  function enhance(){
    queued=false;
    const modal=document.querySelector('details[open] .search-modal');
    const open=!!modal;
    document.body.classList.toggle('sxt-search-open-v121',open);
    const mobile=document.querySelector('.cloud-search-mobile');
    const mobileInput=mobile?.querySelector('input[type="search"]');
    const mobileOpen=!!(mobileInput&&mobile.getClientRects().length);
    document.body.classList.toggle('sxt-cloud-mobile-v117',mobileOpen);
    const input=mobileOpen?mobileInput:modal?.querySelector('input[name="q"]');
    document.body.classList.toggle('sxt-search-has-query-v116',!!(open&&input?.value.trim()));
    const root=document.getElementById('cloud-search-results');
    if(!root)return;
    const scroll=root.querySelector('.cloud-search-results__scroll')||root;
    let all=scroll.querySelector('.sxt-search-all-v118');
    if(!all){
      all=document.createElement('a');all.className='sxt-search-all-v118';
      all.textContent=document.documentElement.lang.startsWith('en')?'View all results':'Вижте всички резултати';
      scroll.append(all);
    }
    const query=input?.value.trim()||'';
    if(all.hidden!==!query)all.hidden=!query;
    const form=modal?.querySelector('form.search-modal__form');
    const url=new URL(form?.getAttribute('action')||'/a/search',location.origin);
    url.searchParams.set('q',query);
    if(all.getAttribute('href')!==url.pathname+url.search)all.setAttribute('href',url.pathname+url.search);
    if(scroll.lastElementChild!==all)scroll.append(all);
    let brands=scroll.querySelector('.sxt-search-brands-v120');
    if(!brands){
      brands=document.createElement('a');brands.className='sxt-search-brands-v120';
      brands.textContent=document.documentElement.lang.startsWith('en')?'View all brands':'Вижте всички марки';
      brands.href='/pages/brands-collection-page';
      scroll.insertBefore(brands,all);
    }
    root.querySelectorAll('.block-products > dl').forEach(grid=>{
      if(grid.style.getPropertyValue('display')!=='grid'||grid.style.getPropertyPriority('display')!=='important')grid.style.setProperty('display','grid','important');
      if(!grid.classList.contains('sxt-search-grid-v82'))grid.classList.add('sxt-search-grid-v82');
      grid.querySelectorAll(':scope > dt.cs-item').forEach(card=>{
        if(!card.classList.contains('sxt-search-card-v82'))card.classList.add('sxt-search-card-v82');
      });
    });
    const view=window.visualViewport;
    const height=view?.height||innerHeight, offset=view?.offsetTop||0;
    const field=input?.closest('.field')||input;
    const bounds=modal?.querySelector('.search-modal__content')?.getBoundingClientRect();
    const top=Math.max(offset,Math.min(mobileOpen?mobile.getBoundingClientRect().bottom:(field?.getBoundingClientRect().bottom||offset+64)+12,offset+height-100));
    const left=mobileOpen?0:Math.max(12,bounds?.left||12);
    const width=mobileOpen?innerWidth:Math.min(bounds?.width||innerWidth-24,innerWidth-left-12);
    const available=Math.max(80,offset+height-top-12);
    for(const [key,value] of Object.entries({'--sxt-search-top-v116':top+'px','--sxt-search-left-v116':left+'px','--sxt-search-width-v116':width+'px','--sxt-search-viewport-v117':height+'px'})){
      if(root.style.getPropertyValue(key)!==value)root.style.setProperty(key,value);
    }
    setStyle(root,'max-height',available+'px');
    setStyle(root,'overflow','hidden');
    setStyle(scroll,'max-height',available+'px');
    setStyle(scroll,'overflow-y','auto');
    setStyle(scroll,'overflow-x','hidden');
    setStyle(scroll,'box-sizing','border-box');
    root.querySelectorAll('dt.cs-item').forEach(item=>{
      const detail=[...item.parentElement.children].find(node=>node.tagName==='DD'&&node.dataset.index===item.dataset.index&&node.dataset.id===item.dataset.id);
      if(!detail)return;
      const price=detail.querySelector('.price:not(.cs-list-price),.sxt-search-now-v82');
      const amount=price?.textContent.trim().replace(/([0-9])[.,]00(?![0-9.,])/g,'$1');if(!amount)return;
      let copy=item.querySelector('.sxt-search-inline-price-v116');
      if(!copy){copy=document.createElement('div');copy.className='sxt-search-inline-price-v116';item.append(copy)}
      if(copy.textContent!==amount)copy.textContent=amount;
    });
    // V119: hide zero cents in search presentation only; retain real fractions.
    root.querySelectorAll('.sxt-search-now-v82,.sxt-current-grid').forEach(price=>{
      const walker=document.createTreeWalker(price,NodeFilter.SHOW_TEXT);
      while(walker.nextNode()){
        const node=walker.currentNode;
        const value=node.nodeValue.replace(/([0-9])[.,]00(?![0-9.,])/g,'$1');
        if(value!==node.nodeValue)node.nodeValue=value;
      }
    });
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(enhance)}};
  // Ignore our own style writes and unrelated animated page elements.
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','open','hidden']});
  document.addEventListener('input',event=>{if(event.target.matches('.search-modal input[name="q"],.cloud-search-mobile input[type="search"]'))schedule()});
  window.visualViewport?.addEventListener('resize',schedule);
  window.visualViewport?.addEventListener('scroll',schedule);
  addEventListener('resize',schedule);addEventListener('scroll',schedule,{passive:true});
  document.addEventListener('cloud-search:render',schedule);schedule();
})();
/* V124: products and the two navigation buttons only. */
(()=>{
  const style=document.createElement('style');
  style.id='sxt-search-products-only-v124';
  style.textContent=`
    html body .sxt-search-shortcuts,
    html body #sxt-mobile-suggestions-v123,
    html body #cloud-search-results .block-pages,
    html body #cloud-search-results .suggestions {display:none!important}
  `;
  document.head.append(style);
})();/* V125: visible exit controls, using the existing close handlers. */
(()=>{
  const style=document.createElement('style');
  style.textContent=`
    .search-modal .sxt-search-exit-v125{display:flex!important;align-items:center;justify-content:center;gap:8px;position:relative!important;margin:0 0 16px auto!important;padding:10px 14px!important;min-height:42px;border:1px solid #660033!important;background:#fff!important;color:#660033!important;font:600 13px/1.4 Arial,sans-serif;cursor:pointer;text-decoration:none!important;box-shadow:none!important}
    .search-modal .sxt-search-exit-v125::before{content:'×';font-size:22px;line-height:1}
    .search-modal .sxt-search-exit-v125::after{display:none!important}
    .search-modal .sxt-search-exit-v125:hover{background:#660033!important;color:#fff!important}
    .search-modal .sxt-search-exit-v125:focus-visible{outline:2px solid #660033;outline-offset:3px}
    .cloud-search-mobile .cloud-search-mobile__cancel{display:flex!important;align-items:center!important;justify-content:center!important;min-height:42px!important;color:#660033!important;font-size:13px!important;font-weight:600!important;text-decoration:none!important;white-space:nowrap!important;padding:8px 12px!important}
  `;document.head.append(style);
  let queued=false;
  function update(){
    queued=false;
    const en=document.documentElement.lang.startsWith('en');
    document.querySelectorAll('.search-modal__content').forEach(content=>{
      if(content.querySelector('.sxt-search-exit-v125'))return;
      const button=document.createElement('button');button.type='button';button.className='sxt-search-exit-v125';
      button.textContent=en?'Close search':'Затвори търсенето';
      button.addEventListener('click',event=>{
        event.preventDefault();event.stopPropagation();
        const host=content.closest('search-modal');
        if(typeof host?.close==='function')host.close();
        else content.querySelector('.field button[type="button"]')?.click();
      });
      content.prepend(button);
    });
    document.querySelectorAll('.cloud-search-mobile__cancel').forEach(cancel=>{
      const label=en?'Close':'Затвори';
      if(cancel.textContent!==label)cancel.textContent=label;
      if(cancel.getAttribute('aria-label')!==(en?'Close search':'Затвори търсенето'))cancel.setAttribute('aria-label',en?'Close search':'Затвори търсенето');
    });
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true});schedule();
})();
